import { createSlice } from '@reduxjs/toolkit';

interface createUsualAccountStepperState {
  totalStep: number;
  currentStep: number;
}

const initialState: createUsualAccountStepperState = {
  totalStep: 2,
  currentStep: 1,
};

export const createUsualAccountStepperSlice = createSlice({
  name: 'createUsualAccountStepper',
  initialState,
  reducers: {
    nextStep: (state) => {
      if (state.currentStep < state.totalStep) {
        state.currentStep += 1;
      }
    },
    prevStep: (state) => {
      if (state.currentStep > 1) {
        state.currentStep -= 1;
      }
    },
    resetCreateUsualAccountStepperData: () => initialState,
  },
});

export const { nextStep, prevStep, resetCreateUsualAccountStepperData } = createUsualAccountStepperSlice.actions;

export const { reducer: createUsualAccountStepperReducer } = createUsualAccountStepperSlice;
